import Vue from 'vue';
import GAuth from 'vue-google-oauth2';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
Vue.config.productionTip = false;
// Google OAuth 配置
const gauthOption = {
	clientId: '249789103608-q6l1sajnbtidmc0uo7a1j6n36ids3b75.apps.googleusercontent.com',
	scope: 'profile email',
	prompt: 'select_account',
	// 2. 建议使用弹窗模式，它通常更稳定，也无需配置重定向 URI
	ux_mode: 'popup',
};
Vue.use(GAuth, gauthOption);
new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
